import { getRandomIntBetween } from 'constants/helper';

export const randomizeArray = (arr) => {
  if (!arr) {
    return null;
  }
  let currentIndex = arr.length;
  let temporaryValue;
  let randomIndex;
  while (currentIndex !== 0) {
    randomIndex = getRandomIntBetween(0, currentIndex - 1);
    currentIndex -= 1;
    temporaryValue = arr[currentIndex];
    arr[currentIndex] = arr[randomIndex];
    arr[randomIndex] = temporaryValue;
  }
  return arr;
};

String.prototype.underscoreLess = function () {
  return this.replace(/_/g, ' ');
};

String.prototype.toProperCase = function () {
  return this.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
};

/*
    truncate string
  */
export const truncate = (str, n) => (str && str.length > n ? `${str.substr(0, n - 1)}...` : str);
